import { Module } from 'vuex';
import * as types from '../mutation-types';
import api from '../../api/modules/dashboards';

interface State {
  dashboard: DashboardResponse | null;
}
const initialState: State = {
  dashboard: null,
};

const dashboardModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    dashboard: state => state.dashboard,
  },
  actions: {
    async getDashboardData({ commit }) {
      const data = await api.getDashboardData();
      commit(types.SET_DASHBOARD, data);
    },
  },
  mutations: {
    [types.SET_DASHBOARD](state: State, data: DashboardResponse) {
      console.log(data);
      state.dashboard = data;
    },
  },
};

export default dashboardModule;
